var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 .42A9.7 9.7 0 0 0 .22 10 9.7 9.7 0 0 0 10 19.58a9.88 9.88 0 0 0 5.52-1.66 1.04 1.04 0 1 0-1.16-1.74A7.77 7.77 0 0 1 10 17.5 7.62 7.62 0 0 1 2.3 10 7.62 7.62 0 0 1 10 2.5a7.62 7.62 0 0 1 7.7 7.5v.74a1.63 1.63 0 0 1-3.24 0V10A4.46 4.46 0 1 0 10 14.38a4.48 4.48 0 0 0 3.22-1.35 3.7 3.7 0 0 0 6.56-2.29V10A9.7 9.7 0 0 0 10 .42Zm0 11.88a2.3 2.3 0 1 1 2.38-2.3A2.34 2.34 0 0 1 10 12.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/at.94a19729.svg";
export { ForwardRef as ReactComponent };